import { AnalyticsPreferences } from "../../components/AnalyticsPreferences";
import React from "react";
import { SEOHead } from "../../components/SEOHead";

export default function Privacy() {
  return (
    <div
      className="container"
      style={{
        maxWidth: 800,
        margin: "0 auto",
        padding: "clamp(16px, 4vw, 32px)",
      }}
    >
      <SEOHead
        title="Privacy Policy"
        description="Etlyn's privacy policy — how we collect, use and protect your data. Learn about your rights and our commitment to transparency."
        path="/privacy"
      />
      <div
        className="editorial-card"
        style={{
          background: "#fff",
          borderRadius: 12,
          boxShadow: "0 1px 2px rgba(0,0,0,0.04)",
          padding: "clamp(24px, 5vw, 40px)",
          margin: "32px 0",
        }}
      >
        <header style={{ marginBottom: 32 }}>
          <h1
            className="heading-1"
            style={{
              fontSize: "clamp(24px, 5vw, 32px)",
              fontWeight: 700,
              fontFamily: "Inter, Arial, sans-serif",
              color: "#0D2B7E",
              margin: 0,
            }}
          >
            Privacy Policy
          </h1>
          <p
            className="body-large"
            style={{
              fontSize: 16,
              color: "#666D7C",
              marginTop: 8,
              lineHeight: 1.6,
            }}
          >
            Last updated: <time dateTime="2026-09-12">September 12, 2026</time>
          </p>
        </header>
        <section style={{ marginBottom: 28 }}>
          <h2
            className="heading-2"
            style={{
              fontSize: 22,
              fontWeight: 700,
              color: "#333D51",
              marginBottom: 12,
            }}
          >
            Overview
          </h2>
          <p
            className="body"
            style={{ fontSize: 14, color: "#333D51", lineHeight: 1.7 }}
          >
            Etlyn Software Agency (“we”, “us”, “our”) is committed to protecting
            your privacy and handling your data transparently. This policy
            explains what information we collect, how we use it, and your rights
            regarding your data.
          </p>
        </section>
        <section style={{ marginBottom: 28 }}>
          <h2
            className="heading-2"
            style={{
              fontSize: 22,
              fontWeight: 700,
              color: "#333D51",
              marginBottom: 12,
            }}
          >
            Information We Collect
          </h2>
          <ul
            style={{
              paddingLeft: 20,
              color: "#333D51",
              fontSize: 14,
              lineHeight: 1.7,
            }}
          >
            <li>
              Contact details (name, email) you provide via forms or
              communication.
            </li>
            <li>
              Usage data (browser type, device, pages visited) for analytics.
            </li>
            <li>Any other information you choose to share with us.</li>
          </ul>
        </section>
        <section style={{ marginBottom: 28 }}>
          <h2
            className="heading-2"
            style={{
              fontSize: 22,
              fontWeight: 700,
              color: "#333D51",
              marginBottom: 12,
            }}
          >
            How We Use Your Information
          </h2>
          <ul
            style={{
              paddingLeft: 20,
              color: "#333D51",
              fontSize: 14,
              lineHeight: 1.7,
            }}
          >
            <li>To respond to inquiries and provide requested services.</li>
            <li>To improve our website, products, and customer experience.</li>
            <li>To comply with legal obligations.</li>
          </ul>
        </section>
        <section style={{ marginBottom: 28 }}>
          <h2
            className="heading-2"
            style={{
              fontSize: 22,
              fontWeight: 700,
              color: "#333D51",
              marginBottom: 12,
            }}
          >
            Cookies & Analytics
          </h2>
          <p
            className="body"
            style={{ fontSize: 14, color: "#333D51", lineHeight: 1.7 }}
          >
            Etlyn uses first-party, cookieless analytics to understand product
            usage and improve content, usability and marketing. No analytics
            cookies or persistent visitor identifiers are used. Temporary random
            identifiers, attribution and queued events stay in memory and reset
            when the page reloads. We store public page and blog URLs without
            query strings or fragments, event timestamps, referring domains,
            campaign labels, selected click targets, approximate country/city,
            browser, device and platform information in our analytics database
            for up to 400 days. We do not store raw IP addresses, precise
            location, private URL parameters, referring page paths, advertising
            click IDs or form contents in analytics events. Location can be
            unavailable or inaccurate. Analytics is not used to identify you
            across websites. You can disable collection below; only your
            preference is saved in this browser. Existing analytics refusals, Do
            Not Track and Global Privacy Control are respected. Disabling clears
            the in-memory queue and stops future collection; it does not delete
            already received events. Contact Etlyn about data requests. Hosting
            logs are separate from this analytics store.
          </p>
          <AnalyticsPreferences />
        </section>
        <section style={{ marginBottom: 28 }}>
          <h2
            className="heading-2"
            style={{
              fontSize: 22,
              fontWeight: 700,
              color: "#333D51",
              marginBottom: 12,
            }}
          >
            Third-Party Services
          </h2>
          <p
            className="body"
            style={{ fontSize: 14, color: "#333D51", lineHeight: 1.7 }}
          >
            We may use trusted third-party providers (e.g., hosting, analytics)
            who process data on our behalf. These providers are required to
            protect your information and comply with applicable laws.
          </p>
        </section>
        <section style={{ marginBottom: 28 }}>
          <h2
            className="heading-2"
            style={{
              fontSize: 22,
              fontWeight: 700,
              color: "#333D51",
              marginBottom: 12,
            }}
          >
            Your Rights
          </h2>
          <ul
            style={{
              paddingLeft: 20,
              color: "#333D51",
              fontSize: 14,
              lineHeight: 1.7,
            }}
          >
            <li>
              You may request access, correction, or deletion of your personal
              data.
            </li>
            <li>
              Contact us at{" "}
              <a
                href="mailto:info@etlyn.com"
                style={{ color: "#228be6", textDecoration: "underline" }}
              >
                info@etlyn.com
              </a>{" "}
              for any privacy-related requests.
            </li>
          </ul>
        </section>
        <section style={{ marginBottom: 28 }}>
          <h2
            className="heading-2"
            style={{
              fontSize: 22,
              fontWeight: 700,
              color: "#333D51",
              marginBottom: 12,
            }}
          >
            Updates
          </h2>
          <p
            className="body"
            style={{ fontSize: 14, color: "#333D51", lineHeight: 1.7 }}
          >
            This policy may be updated periodically. Changes will be posted on
            this page with the effective date.
          </p>
        </section>
        <footer
          style={{
            borderTop: "1px solid #e1e5e9",
            marginTop: 32,
            paddingTop: 16,
            fontSize: 14,
            color: "#666D7C",
            textAlign: "center",
          }}
        >
          <div style={{ marginBottom: 4 }}>
            &copy; {new Date().getFullYear()} Etlyn Software Agency. All rights
            reserved.
          </div>
          <div style={{ marginBottom: 4 }}>
            All content, code, and designs are the property of Etlyn Software
            Agency unless otherwise stated.
          </div>
          <div>
            For questions, contact{" "}
            <a
              href="mailto:info@etlyn.com"
              style={{ color: "#228be6", textDecoration: "underline" }}
            >
              info@etlyn.com
            </a>
          </div>
        </footer>
      </div>
    </div>
  );
}
